import { render, staticRenderFns } from "./InsertLinkModal.vue?vue&type=template&id=94df2778"
import script from "./InsertLinkModal.vue?vue&type=script&lang=js"
export * from "./InsertLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports